import { render } from "./EmployeePreviewCard.vue?vue&type=template&id=8458e534"
import script from "./EmployeePreviewCard.vue?vue&type=script&lang=js"
export * from "./EmployeePreviewCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__